export default __webpack_public_path__ + "static/media/corporate10.fc4335fb.webp";